// extracted by mini-css-extract-plugin
export default {"cont":"ProductsImg_cont__L-ILY","name":"ProductsImg_name__uSYae","productsImg":"ProductsImg_productsImg__oofWi"};